import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApdPjKwS60GC5E1EA1qC/
NhpDbJZCqge7YUBGPO4ll21gyAqIACML7HR5uFI8rscllvQQ6oVDJyuqLFwbOH2d
Equ4Tr9W34BozQfbY8N7KtyAxCAzfljhjnzKjjXUFpNdl3WY3C9ymI9u+ywCnEdY
xP8Oa6LAJDxHh51UAqJzmlZY6FExfx4S2EhLQDvrnhsy+Z0Ovtq9L4AiS2HMcKtG
BROEz2KrcukCmcjE5O9sUik6GRQqJrNcoN2QpxqwJB1HhFYCT3VlH+Khf8H1Lx+e
eNOealbl/POqEKqP+cy1zDUGGyRZag/+55iT5EQSNR2BY2O7opISOzyt5xryNsjp
jQIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

